<template>
    <div>
        <button class="btn btn-sm btn-dark mb-1" v-on:click="back">
            <feather-icon icon="ArrowLeftIcon" class="mr-25"></feather-icon>Geri
        </button>
        <div class="row">
            <div class="col-md-auto">
                <reference-model-drawer :merge="model.BaseType == 'KAMYON' || model.BaseType == 'KIRKAYAK'"
                                        :front-axles="model.FrontAxles"
                                        :back-axles="model.BackAxles"></reference-model-drawer>
            </div>
            <div class="col-md">
                <b-overlay :show="baseTypesLoading || typeLoading || modelDataLoading || tireReferenceModelLoading" opacity="0.2" rounded="sm">
                    <b-card class="mb-0">
                        <div class="row">
                            <div class="col-xl-6  mb-2 mb-xl-0">
                                <h5>Model Araç Bilgileri</h5>
                                <hr/>
                                <div class="row">
                                    <div class="col-12 mb-1">
                                        <label class="form-label">Referans Model İsmi</label>
                                        <input type="text" class="form-control" placeholder="Referans Model İsmi" v-model="model.Name">
                                    </div>
                                    <div class="col-12 mb-1">
                                        <label class="form-label">Araç Tipi</label>
                                        <div>
                                            <b-form-radio v-for="baseType in groupedBaseTypes" v-on:change="getTypes" inline :key="baseType.Id" v-model="model.BaseType" :value="baseType.Name">{{baseType.Name}}</b-form-radio>
                                        </div>   
                                    </div>
                                    <div class="col-12 mb-1">
                                        <v-select-list multiple :selectable="() => model.Type.length < 1" v-model="model.Type" placeholder="Araç Tipi" label="Name" img='Image' :options="types"></v-select-list>
                                    </div>
                                    <div class="col-12 mb-1">
                                        <ul class="list-group">
                                            <li class="list-group-item axle-header">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <div> 
                                                        Ön Dingil Sayısı : <b>{{ model.FrontAxles.length }}/{{ model.FrontMax }}</b>
                                                    </div>
                                                    <div>
                                                        <button :disabled="model.FrontAxles.length == model.FrontMax" class="btn btn-icon btn-success btn-sm" v-on:click="addTire(true)">
                                                            <feather-icon icon="PlusIcon"></feather-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </li>
                                            <template v-if="model.FrontAxles.length">
                                                <li v-for="(axle,index) in model.FrontAxles" class="list-group-item" :key="'fa'+index">
                                                    <div class="d-flex align-items-center">
                                                        <div class="row w-100">
                                                            <div class="col-12">
                                                                <div class="font-weight-bolder axle-order">Ön {{index + 1}}. Dingil</div>
                                                            </div>
                                                            <div class="col-12 mb-1">
                                                                <label class="form-label">Lastik Adedi</label>
                                                                <b-form-spinbutton size="sm" v-model="axle.tire" min="2" max="8" step="2"/>
                                                            </div>
                                                            <div class="col-md-12 mb-1">
                                                                <label class="form-label">Referans Lastik Modeli</label>
                                                                <v-select-list placeholder="Referans Lastik Modeli" v-model="axle.tireReferenceModel" label="Name" :options="filterTireReferenceModels('FRONT',index + 1)"/>
                                                            </div>
                                                            <div class="col-xl-12 mb-1 mb-xl-0">
                                                                <label class="form-label">Lastik Ömrü (KM)</label>
                                                                <b-form-input placeholder="Lastik Ömrü (KM)" v-model="axle.life" size="sm"></b-form-input>
                                                            </div>
                                                        </div>
                                                        <div class="ml-1">
                                                            <button :disabled="model.FrontAxles.length == 1" class="btn btn-sm btn-icon btn-danger" v-on:click="$delete(model.FrontAxles,index)">
                                                                <feather-icon icon="TrashIcon"></feather-icon>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </li>
                                            </template>
                                        </ul>
                                        <ul class="list-group mt-1">
                                            <li class="list-group-item axle-header">
                                                <div class="d-flex align-items-center justify-content-between">
                                                    <div>Arka Dingil Sayısı : <b>{{ model.BackAxles.length }}/{{ model.BackMax }}</b></div>
                                                    <div>
                                                        <button :disabled="model.BackAxles.length == model.BackMax" class="btn btn-icon btn-success btn-sm" v-on:click="addTire(false)">
                                                            <feather-icon icon="PlusIcon"></feather-icon>
                                                        </button>
                                                    </div>
                                                </div>
                                            </li>
                                            <template v-if="model.BackAxles.length">
                                                <li v-for="(axle,index) in model.BackAxles" class="list-group-item" :key="'ba'+index">
                                                    <div class="d-flex align-items-center">
                                                        <div class="row w-100">
                                                            <div class="col-12">
                                                                <div class="font-weight-bolder axle-order">Arka {{index + 1}}. Dingil</div>
                                                            </div>
                                                            <div class="col-12 mb-1">
                                                                <label class="form-label">Lastik Adedi</label>
                                                                <b-form-spinbutton size="sm" v-model="axle.tire" min="2" max="8" step="2"/>
                                                            </div>
                                                            <div class="col-md-12 mb-1">
                                                                <label class="form-label">Referans Lastik Modeli</label>
                                                                <v-select-list  placeholder="Referans Lastik Modeli" v-model="axle.tireReferenceModel" label="Name" :options="filterTireReferenceModels('BACK',index + 1)"/>
                                                            </div>

                                                            <div class="col-xl-12 mb-1 mb-xl-0">
                                                                <label class="form-label">Lastik Ömrü (KM)</label>
                                                                <b-form-input placeholder="Lastik Ömrü (KM)" v-model="axle.life" size="sm"></b-form-input>
                                                            </div>
                                                        </div>
                                                        <div class="ml-1">
                                                            <button :disabled="model.BackAxles.length == 1" class="btn btn-sm btn-icon btn-danger" v-on:click="$delete(model.BackAxles,index)">
                                                                <feather-icon icon="TrashIcon"></feather-icon>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-xl-6">
                                <h5>Maliyet, Operasyon ve Tüketim Bilgileri 
                                    <feather-icon icon="InfoIcon" v-b-tooltip.hover title="Bu bilgiler referans model ile hesaplama sayfasında kullanılacaktır." ></feather-icon>
                                </h5>
                                <hr/>
                                <div class="row">
                                    <div class="col-12 ">
                                        <b-form-checkbox v-model="model.AvgFuelConsumptionCheck" v-on:change="setZero(1)" class="custom-control-success" switch>Ortalama Yakıt Tüketimi Değerini Hesaba Kat</b-form-checkbox>
                                    </div>
                                    <div class="col-12 mb-1">
                                        <label class="form-label">Ortalama Yakıt Tüketimi (LT/KM)</label>
                                        <b-form-input :disabled="!model.AvgFuelConsumptionCheck" v-model="model.AvgFuelConsumption" placeholder="Ortalama Yakıt Tüketimi (LT/KM)"></b-form-input>
                                    </div>
                                    <div class="col-12">
                                        <b-form-checkbox v-model="model.AvgAdBlueConsumptionCheck" v-on:change="setZero(2)" class="custom-control-success" switch>Ortalama Adblue Tüketimi Değerini Hesaba Kat</b-form-checkbox>
                                    </div>
                                    <div class="col-12 mb-1">
                                        <label class="form-label">Ortalama Adblue Tüketimi (LT/KM)</label>
                                        <b-form-input :disabled="!model.AvgAdBlueConsumptionCheck" v-model="model.AvgAdBlueConsumption" placeholder="Ortalama Adblue Tüketimi (LT/KM)"></b-form-input>
                                    </div>
                                    <div class="col-12 mb-1">
                                        <label class="form-label">Taşınan Yük Miktarı (TON)</label>
                                        <b-form-input v-model="model.VehicleCapacity" placeholder="Taşınan Yük Miktarı (TON)"></b-form-input>
                                    </div>
                                    <div class="col-12 mb-1">
                                        <label class="form-label">Sabit Maliyet (TL/GÜN)</label>
                                        <b-form-input v-model="model.FixedCost" placeholder="Sabit Maliyet (TL/GÜN)"></b-form-input>
                                    </div>
                                    <div class="col-12 mb-1">
                                        <label class="form-label">Kar Oranı (%)</label>
                                        <b-form-input v-model="model.ProfitRate" placeholder="Kar Oranı (%)"></b-form-input>
                                    </div>
                                    <div class="col-12" v-if="model.TotalTireUnitCost">
                                        <div class="alert alert-danger">
                                            <div class="alert-body">
                                                <b>Hesaplanan Lastik Maliyeti:</b> {{model.TotalTireUnitCost}} TL/TON-KM
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 text-right">
                                        <div class="row justify-content-between">
                                            <div class="col-md-auto mb-1"><v-executer :action="calculateTireCost" :loading="calculating" variant="secondary" text="Lastik Maliyetini Görüntüle"></v-executer></div>
                                            <div class="col-md-auto mb-1"><v-executer :action="createOrUpdate" :editing=" $route.params.id != 0 ? true : false" :loading="loading"></v-executer></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-card>
                </b-overlay>
            </div>
        </div>
    </div>
</template>

<script>
import { BCard,BFormRadio,BFormSpinbutton,BFormInput,BFormCheckbox,VBTooltip,BOverlay } from 'bootstrap-vue'
import ReferenceModelDrawer from './components/ReferenceModelDrawer.vue'
import VehicleDefinitionApi from '@/api/vehicle-definitions'
import CalculatePriceApi from '@/api/calculate-price'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import Additional from '@/utilities/additional'

export default {
    components:{
        BCard,
        BFormRadio,
        BFormSpinbutton,
        BFormInput,
        ReferenceModelDrawer,
        FeatherIcon,
        BOverlay,
        BFormCheckbox
    },
    directives:{
        "b-tooltip":VBTooltip
    },
    data() {
        return {
            loading:false,
            editing: this.$route.params.id != 0 || this.$route.params.id != '0' ?  true : false,
            id: this.$route.params.id,
            baseTypesLoading:false,
            modelDataLoading:false,
            typeLoading:false,
            tireReferenceModelLoading:false,
            calculating:false,
            baseTypes:[],
            types:[],
            tireReferenceModels:[],
            model:{
                Id:0,
                FrontMax:1,
                BackMax:4,
                Name:null,
                BaseType:null,
                Type:[],
                FrontAxles:[
                    {tire:2, tireReferenceModel:null, price:0,life:0}
                ],
                BackAxles:[
                    {tire:2,tireReferenceModel:null,price:0,life:0}
                ],
                AvgFuelConsumption:0,
                AvgAdBlueConsumption:0,
                TotalTireUnitCost:null,
                FixedCost:0,
                ProfitRate:0,
                AvgFuelConsumptionCheck:true,
                AvgAdBlueConsumptionCheck:true,
                VehicleCapacity:0,
            }
        }
    },
    mounted(){
        this.getBaseTypes().then(()=>{ this.getModelData() })
        this.getTireReferenceModels()
    },
    watch:{
        "model.BaseType":{
            handler(newValue,oldValue){
                this.model.Type = []
                if(newValue == 'KAMYON' || newValue == 'KIRKAYAK'){
                    this.model.FrontMax = 1
                    if(oldValue != null && this.model.FrontAxles.length > 1){
                        this.model.FrontAxles = this.model.FrontAxles.slice(0,-this.model.FrontAxles.length + 1)
                    }
                }
                else{ this.model.FrontMax = 4 }
            },
            deep:true
        }
    },
    methods:{
        getTireReferenceModels(){
            return new Promise((resolve)=>{
                this.tireReferenceModelLoading = true
                CalculatePriceApi.TireReferenceModel.List().then((res)=>{
                    this.tireReferenceModels = res.data.Data
                    this.tireReferenceModelLoading = false
                    resolve()
                })
            })
        },
        filterTireReferenceModels(PartLocation,AxleOrder){
            return this.tireReferenceModels.filter(trm=> trm.TireReferenceModelAxleInfos.find(trma=> trma.PartLocation == PartLocation && trma.AxleOrder == AxleOrder))
        },
        setZero(number){
            if(number == 1){ this.model.AvgFuelConsumptionCheck == false ? this.model.AvgFuelConsumption = 0 : null }
            else if(number == 2){ this.model.AvgAdBlueConsumptionCheck == false ? this.model.AvgAdBlueConsumption = 0 : null }
        },
        calculateTireCost(){
            let model = {
                TiresOfVehicleReferenceCostCalculateRequestModel:[
                    ...this.model.FrontAxles.map((fa,index)=>{ return { 
                        AxleOrder:index,
                        TireCount:fa.tire,
                        TireUnitPrice:parseFloat(fa.price),
                        TireLifespanKM:parseFloat(fa.life),
                        TireReferenceModelId:fa.tireReferenceModel?.Id,
                        PartLocation:"FRONT"
                    }}),
                    ...this.model.BackAxles.map((fa,index)=>{ return { 
                        AxleOrder:index,
                        TireCount:fa.tire,
                        TireUnitPrice:parseFloat(fa.price),
                        TireLifespanKM:parseFloat(fa.life),
                        TireReferenceModelId:fa.tireReferenceModel?.Id,
                        PartLocation:"BACK"
                    }}),
                ],
                VehicleCapacity:parseFloat(this.model.VehicleCapacity),
            }
            this.calculating = true
            CalculatePriceApi.ReferenceModel.CalculateTireCost(model).then(res=>{
                if(res.data.Success){
                    this.model.TotalTireUnitCost = res.data.Data
                }
                this.calculating = false
            }).catch(err=>{
                this.calculating = false
            })
        },
        getModelData(){
            if(this.id != "0" || this.id != 0){
                this.modelDataLoading = true
                CalculatePriceApi.ReferenceModel.GetById(this.id)
                .then(response => {
                    this.model.Name = response.data.Data.VehicleReferenceModel.ReferenceModelNameManuel
                    this.model.AvgFuelConsumption = response.data.Data.VehicleReferenceModel.AvgFuelConsumption
                    this.model.AvgAdBlueConsumption = response.data.Data.VehicleReferenceModel.AvgAdBlueConsumption
                    this.model.FixedCost = response.data.Data.VehicleReferenceModel.FixedCost
                    this.model.ProfitRate = response.data.Data.VehicleReferenceModel.ProfitRate
                    this.model.AvgFuelConsumptionCheck = response.data.Data.VehicleReferenceModel.AvgFuelConsumptionCheck
                    this.model.AvgAdBlueConsumptionCheck = response.data.Data.VehicleReferenceModel.AvgAdBlueConsumptionCheck
                    this.model.VehicleCapacity = response.data.Data.VehicleReferenceModel.VehicleCapacity
                    this.model.TotalTireUnitCost = response.data.Data.VehicleReferenceModel.TotalTireUnitCost
                    this.model.BaseType = this.groupedBaseTypes.find(gbt => gbt.ReferenceModelSameGroup == response.data.Data.VehicleReferenceModel.VehicleTypeBaseTypeGroupNumber).Name
                    this.getTypes().then(()=>{
                        this.model.Type = this.types.filter(t=> response.data.Data.VehicleTypeIds.includes(t.Id))
                    })
                    this.getTireReferenceModels().then(res=>{
                        this.model.FrontAxles = response.data.Data.TiresOfVehicleReferenceCostCalculate.filter(t=>t.PartLocation == 'FRONT').sort((a,b)=> { a.AxleOrder - b.AxleOrder }).map(r=>{ return { tireReferenceModel:this.tireReferenceModels.find(tr=> tr.Id == r.TireReferenceModelId), tire:r.TireCount,price:r.TireUnitPrice,life:r.TireLifespanKM } })
                        this.model.BackAxles = response.data.Data.TiresOfVehicleReferenceCostCalculate.filter(t=>t.PartLocation == 'BACK').sort((a,b)=> { a.AxleOrder - b.AxleOrder }).map(r=>{ return { tireReferenceModel:this.tireReferenceModels.find(tr=> tr.Id == r.TireReferenceModelId), tire:r.TireCount,price:r.TireUnitPrice,life:r.TireLifespanKM } })
                    })
                   
                    this.modelDataLoading = false
                }).catch(err=>{
                    this.modelDataLoading = false
                })
            }
        },
        createOrUpdate(){
            let model = {
                VehicleTypeIds: this.model.Type.map(t=>t.Id),
                TiresOfVehicleReferenceModel:[
                    ...this.model.FrontAxles.map((fa,index)=>{ return { 
                        AxleOrder:index,
                        TireCount:fa.tire,
                        TireUnitPrice:parseFloat(fa.price),
                        TireLifespanKM:parseFloat(fa.life),
                        PartLocation:"FRONT",
                        TireReferenceModelId:fa.tireReferenceModel?.Id
                    }}),
                    ...this.model.BackAxles.map((fa,index)=>{ return { 
                        AxleOrder:index,
                        TireCount:fa.tire,
                        TireUnitPrice:parseFloat(fa.price),
                        TireLifespanKM:parseFloat(fa.life),
                        PartLocation:"BACK",
                        TireReferenceModelId:fa.tireReferenceModel?.Id
                    }}),
                ],
                VehicleReferenceModel:{
                    Id: this.id,
                    VehicleTypeBaseTypeGroupNumber: this.groupedBaseTypes.find(gbt => gbt.Name == this.model.BaseType)?.ReferenceModelSameGroup,
                    ReferenceModelNameManuel: this.model.Name,
                    FrontAxleCount: this.model.FrontAxles.length,
                    BackAxleCount: this.model.BackAxles.length,
                    AvgFuelConsumption: parseFloat(this.model.AvgFuelConsumption),
                    AvgAdBlueConsumption: parseFloat(this.model.AvgAdBlueConsumption),
                    FixedCost: parseFloat(this.model.FixedCost),
                    VehicleCapacity: parseFloat(this.model.VehicleCapacity),
                    ProfitRate: parseFloat(this.model.ProfitRate),
                    AvgFuelConsumptionCheck: this.model.AvgFuelConsumptionCheck,
                    AvgAdBlueConsumptionCheck: this.model.AvgAdBlueConsumptionCheck,
                }
            }
            this.loading = true
            CalculatePriceApi.ReferenceModel.CreateOrUpdate(this.editing,model)
            .then(response=>{
                if(response.data.Success){
                    this.$router.push({name:'vehicle-reference-model'})
                }
                this.loading = false
                this.$result(response)
            })
            .catch(error=>{
                this.loading = false
                this.$result(null,error)
            })
        },
        getTypes(){
            return new Promise((resolve,reject)=>{
                let groupNumber = this.groupedBaseTypes.find(gbt => gbt.Name == this.model.BaseType)?.ReferenceModelSameGroup 
                if(groupNumber >= 0){
                    this.typeLoading = true
                    VehicleDefinitionApi.Type.ListOnlyTwoStepByGroupNumber(groupNumber).then(response => {
                        this.types = response.data.Data
                        this.typeLoading = false
                        resolve()
                    }).catch(err=> {
                        console.log(err)
                        this.typeLoading = false
                    })
                }
            })
        },
        getBaseTypes(){
            return new Promise((resolve)=>{
                this.baseTypesLoading = true
                VehicleDefinitionApi.BaseType.List(true).then(response => {
                    this.baseTypes = response.data.Data
                    this.model.BaseType = this.groupedBaseTypes[0].Name
                    if(this.id == "0" || this.id == 0) this.getTypes()
                    resolve()
                    this.baseTypesLoading = false
                }).catch(error => {
                    this.baseTypesLoading = false
                })
            })
            
        },
        addTire(front){
            let max = front ? this.model.FrontMax : this.model.BackMax
            let axles = front ? this.model.FrontAxles : this.model.BackAxles
            if(axles.length < max){
                axles.push({tire:2,price:0,life:0})
            }
        },
        back(){
            this.$router.push({name:'vehicle-reference-model'})
        },
    },
    computed:{
        groupedBaseTypes(){
            const gropedMap = this.baseTypes.reduce(
                (entryMap, e) => entryMap.set(e.ReferenceModelSameGroup, [...entryMap.get(e.ReferenceModelSameGroup)||[], e]),
                new Map()
            )
            return [...gropedMap.values()].map(g=>{ return { Id:g[0].Id, Name:g.map(bt => bt.Name).join('/'), ReferenceModelSameGroup: g[0].ReferenceModelSameGroup} })
        },
    }
}
</script>

<style lang="scss">
.axle-order{
    font-size:0.85rem
}
.axle-header{
    background-color: #f3f2f7 !important;
}

.dark-layout .axle-header{
    background-color: #343d55 !important;
}

</style>